<template>
	<div class="distributionUser">
		<UserIntegral ref="userIntegral"/>
		<FilterForm :fields="searchFields" @submit="search"/>
		<div style="background:#fff;margin:10px;height:50px;line-height:50px;font-size:18px;text-align:left;padding:0px 15px">
			{{$route.query.data?'下级用户':'分销用户'}}
			<el-button size="mini" type="primary" plain @click="getBack" v-if="$route.query.data" ><i class="fa fa-share fa-2" aria-hidden="true"></i>返回分销用户列表</el-button>
		</div>
		<el-table :data="tableData" style="width: 100%" height="1000px">
			<el-table-column prop="user_id" label="编号" align="center"></el-table-column>
			<el-table-column label="基础信息" align="center">
				<template slot-scope="scope">
					<el-avatar :size="'medium'" :src="scope.row.head_pic"></el-avatar>
					<div class="content">
						{{scope.row.nickname}}
						{{scope.row.email}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="上级信息" align="center" prop="level_name" v-if="!$route.query.data"></el-table-column>
			<el-table-column prop="level" label="会员等级" align="center"></el-table-column>
			<el-table-column prop="pay_points" label="积分" align="center"></el-table-column>
			<el-table-column label="性别" align="center">
				<template slot-scope="scope">
					{{scope.row.sex==1?'男':'女'}}<br>
				</template>
			</el-table-column>
			<el-table-column prop="birthday" label="生日" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="openDetail(scope.row)">详情</el-button>
					<el-button type="primary" size="small" @click="openIntegral(scope.row)">积分列表</el-button>
					<el-button type="primary" size="small" @click="distributionUserUnderPage(scope.row)" v-if="!$route.query.data">下级信息</el-button>
					<el-button type="primary" size="small" @click="distributionOrderUnder(scope.row)" v-if="!$route.query.data">下级订单</el-button>
					<el-button type="primary" size="small" @click="revenueBreakdown(scope.row)">收益明细</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import UserIntegral from '../userList/userIntegral.vue';
import {distributionUserUnder} from '../../service/distribution'
import { UserService } from '../../service/user.service';
const searchFields = [
	{ name: '用户名', key: 'username', type: 'input' },
	{ name: '昵称', key: 'nickname', type: 'input' },
	{ name: '手机号', key: 'mobile', type: 'input' },
	{ name: '邮箱', key: 'email', type: 'input' },
	{ name: '会员等级', key: 'level', type: 'input' },
];
	export default {
		name: 'distributionUser',
		components: { UserIntegral },
		data() {
			return {
				tableData: [],
				searchFields,
				searchValue: {},
				loading: false,
				pageOption: {
				total: 0,
				page: 1,
				page_size: 20,
				},
			}
		},
		watch: {
			// '$route.path':{
			// 	handler(){
			// 		this.getList()
			// 	}
			// }
		},
		created() {
			this.getList();
		},
		methods: {
			getList() {
				this.loading = true;
				if(!this.$route.query.data){
					UserService.getList({...this.searchValue, page: this.pageOption.page, page_size: this.pageOption.page_size,type:1}).then(res=>{
						this.loading = false;
						this.pageOption.total = res.totalRow;
						this.pageOption.page = res.page;
						this.tableData = res.data;

					})
				}else{
					distributionUserUnder({user_id:this.$route.query.data}).then(res=>{
						this.pageOption.total = res.totalRow;
						this.pageOption.page = res.page;
						this.tableData = res.data;
						this.loading = false;
					})
				}
			},
			pageChange(index) {
				this.pageOption.page = index;
				this.getList();
			},
			search(data) {
				this.searchValue = data;
				this.getList()
			},
			openIntegral(data) {
				this.$refs.userIntegral.open(data);
			},
			openDetail(data) {
				this.$router.push({path:'/userEdit',query:{type:'edit',data:data}})
			},
			revenueBreakdown(data){
				this.$router.push({path:'/revenueBreakdown',query:{data:data.user_id}})
			},
			distributionUserUnderPage(data){
				this.$router.push({path:'/distributionUser',query:{data:data.user_id}})
				this.getList()
			},
			distributionOrderUnder(data){
				this.$router.push({path:'/distributionUnderorders',query:{data:data.user_id}})
			},
			getBack(){
				this.$router.push('/distributionUser')
				this.getList()
			}
		}
	}
</script>

<style lang="scss" scoped>

.baseInfo {
	display: flex;
	align-items: center;
	.content {
		margin-left: 20px;
		display: flex;
		flex-direction: column;
	}
}
</style>